<template>
  <div v-if="!!entity">
    <div class="row">
      <div class="col"><h1>Uporabnik {{ entity.displayName }}</h1></div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Ime</label>
      <div class="col-sm-8">
        <input class="form-control" type="text"
          :class="{ 'is-invalid': v.invalid('givenName') }"
          v-model="entity.givenName"
          required />
      </div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Priimek</label>
      <div class="col-sm-8">
        <input class="form-control" type="text"
          :class="{ 'is-invalid': v.invalid('surname') }"
          v-model="entity.surname"
          required />
      </div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Email</label>
      <div class="col-sm-8">
        <input class="form-control" type="email"
          :class="{ 'is-invalid': v.invalid('email') }"
          v-model="entity.email"
          required />
      </div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Vloga</label>
      <div class="col-sm-8">
        <SelectEntity
          :required="true"
          apiEntity="Roles"
          v-model="entity.role"
          :invalid="v.invalid('role')"
           />
      </div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Delavec</label>
      <div class="col-sm-8">
        <SelectEntity
          apiEntity="DropDown/Workers"
          v-model="entity.workerId"
          />
      </div>
    </div>

    <div class="row mb-3">
      <label class="col-form-label col-sm-4">Stranka</label>
      <div class="col-sm-8">
        <SelectEntity
          apiEntity="DropDown/Customers"
          v-model="entity.customerId"
          />
      </div>
    </div>

    <RequiredWarning v-show="v.showWarning.value" :missing="v.missing.value" />

    <div class="row sticky-actions py-2 bg-light mb-5">
      <div class="col-2 text-start">
      </div>
      <div class="col-10 text-end">
        <button class="btn btn-outline-secondary me-3" type="button" @click="$router.push({ name: 'Users' })">Prekliči</button>
        <button class="btn btn-success btn-lg me-3" type="button"  @click="saveAsync">Shrani</button>
      </div>
    </div>

  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { setError, startLoading, stopLoading, setSuccess, setWarning } from "../components/Notification"
import { role, useAuth, currentWorkerId } from "../composition-api/useAuth"
import { getEntityAsync } from "../api"
import { useValidation, hasText } from "../composition-api/useValidation"

defineOptions({ name: "UserEdit" })

const router = VueRouter.useRouter()
const route = VueRouter.useRoute()

const { fetchAuthAsync } = useAuth()

const entity = ref(null)

const v = useValidation(() => {
  const e = entity.value
  return {
    givenName: [() => hasText(e?.givenName), "Ime"],
    surname: [() => hasText(e?.surname), "Priimek"],
    email: [() => hasText(e?.email), "Email"],
    role: [() => !!e?.role, "Vloga"],
  }
})

const isNew = computed(() => route.params.userId === "new")

const saveAsync = async () => {
  if (!v.attempt()) return
  v.fromServer(null)
  startLoading("saveUserAsync")
  try {
    const raw = await fetchAuthAsync(`${AZURE_URI}/User`, isNew.value ? "POST" : "PUT", entity.value)
    if (raw?.status !== "ok") {
      throw raw
    }
    console.log(raw)
  } catch (e) {
    v.fromServer(e)
    setError(e)
  }
  stopLoading("saveUserAsync")
}

onMounted(async () => (entity.value = await getEntityAsync(fetchAuthAsync, "User", route.params.userId)))
</script>
